<template>
	<div
		:class="season === 'E' && 'col-12 px-xl-0'"
		v-if="stationData"
		id="station-wrapper"
		ref="station-wrapper"
	>
		<div class="col-12 pt-3">
			<!-- STATION -->
			<h2 class="title-2 w-100 pb-2 pb-md-4 text-grey-900" >
				{{ content.station_aboutTheStation }} {{ stationData.name }}
			</h2>
			<div class="row pt-0 pt-md-5">
				<StationBanner
					:parentStationId="stationData.parentStationId"
					:stationId="stationId"
					v-if="locale === 'fr_FR'"
				/>
				<div class="col-12 col-md-5">
					<div class="d-inline justify-content-start">
						<!-- Desktop -->
						<div class="d-none d-md-block justify-content-between">
							<h3 class="title-3 text-grey-900 pt-2 pb-4" v-if="infoText">
								{{ content.station_GoTo }} {{ stationData.name }}
							</h3>
						</div>
						<!-- Mobile -->
						<a
							class="d-md-none w-100 py-3 py-3"
							data-toggle="collapse"
							type="button"
							data-target="#tf-desc-station-inner"
							aria-expanded="false"
							aria-controls="tf-desc-inner"
						>
							<div
								class="d-flex justify-content-between border-top border-gray py-2"
							>
								<div class="title-3 text-grey-900 pt-2" v-if="infoText">
									{{ content.station_GoTo }} {{ stationData.name }}
								</div>
								<div class="d-flex d-sm-none align-items-center">
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										class="bi bi-chevron-up"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M4 10L8 6L12 10"
											stroke="#1D2329"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>

									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										class="bi bi-chevron-down"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12 6L8 10L4 6"
											stroke="#1D2329"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</div>
							</div>
						</a>
					</div>
					<div
						data-mobile-collapsed
						data-desktop-expanded
						id="tf-desc-station-inner"
						class="collapse pt-2 pt-md-3"
					>
						<div ref="stationDescText" id="stationDescText">
							<div
								v-if="infoText"
								class="body text-grey-900 show-more-less-text"
							>
								<p v-html="infoText"></p>
							</div>
							<div
								class="title-3 text-grey-900 show-more-less-text"
								v-else-if="stationData.pratique"
							>
								<p
									class="popup-content-text body text-grey-900"
									v-html="stationData.pratique"
								></p>
							</div>
						</div>
						<div
							v-if="infoText"
							@click.stop="handleOpenPopup"
							id="description-show-more"
							class="link-large-underline link-default py-3 cursor-pointer"
						>
							<span>{{ content.station_FullDescription }}</span>
							<svg style="color: var(--primary-blue);" width="10" height="10" class="icon">
								<use xlink:href="#___icon___chevron-right-bold"></use>
							</svg>
						</div>
						<!-- <div class="d-none d-md-block justify-content-between pt-3">
							<div
								id="second-interactive-map"
								style="height: 240px; border-radius: var(--border-radius-secondary)"
							>
								<template>
									<Map />
								</template>
							</div>
						</div> -->
						<PopupBase
							v-if="infoText"
							:open="state.popupOpen"
							@closePopup="handleClosePopup"
						>
							<StationPopupContent
								:stationData="stationData"
								@handleClosePopup="handleClosePopup"
							/>
						</PopupBase>
					</div>
				</div>
				<div v-if="season === 'H'" class="col-12 col-md-7">
					<div
						class="d-inline justify-content-start"
						v-if="stationData.reason1body"
					>
						<!-- Desktop -->
						<div class="d-none d-md-block justify-content-between">
							<h3 class="title-3 text-grey-900 pt-2 pb-4">
								{{ content.station_WhyGoTo }} {{ stationData.name }}?
							</h3>
						</div>
						<!-- Mobile -->
						<a
							class="d-md-none w-100 py-3 py-3"
							data-toggle="collapse"
							type="button"
							data-target="#tf-desc-station-adv-inner"
							aria-expanded="false"
							aria-controls="tf-desc-station-adv-inner"
						>
							<div
								class="d-flex justify-content-between py-2 border-top border-gray"
							>
								<div class="title-3 text-grey-900 pt-2">
									{{ content.station_WhyGoTo }} {{ stationData.name }}?
								</div>
								<div class="d-flex d-sm-none align-items-center">
									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										class="bi bi-chevron-up"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M4 10L8 6L12 10"
											stroke="#1D2329"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>

									<svg
										width="16"
										height="16"
										viewBox="0 0 16 16"
										class="bi bi-chevron-down"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M12 6L8 10L4 6"
											stroke="#1D2329"
											stroke-width="2"
											stroke-linecap="round"
											stroke-linejoin="round"
										/>
									</svg>
								</div>
							</div>
						</a>
					</div>
					<div
						v-if="
							stationData.reason1body ||
							stationData.reason2body ||
							stationData.reason3body ||
							stationData.reason4body ||
							stationData.reason5body
						"
						id="tf-desc-station-adv-inner"
						class="collapse pt-2 pt-md-3"
						data-mobile-collapsed
						data-desktop-expanded
					>
						<div v-if="stationData.reason1body" class="media d-flex pb-1">
							<div class="tf-lihe-icons-wrap me-2">
								<svg width="14" height="10" class="icon text-primary-blue">
									<use href="#___icon___check"></use>
								</svg>
							</div>
							<div class="media-body">
								<span class="mt-0 body-strong text-grey-900 font-weight-600">{{
									stationData.reason1title
								}}</span>
								<p class="caption text-grey-900">
									{{ stationData.reason1body }}
								</p>
							</div>
						</div>
						<div v-if="stationData.reason2body" class="media d-flex pb-1">
							<div class="tf-lihe-icons-wrap me-2">
								<svg width="14" height="10" class="icon text-primary-blue">
									<use href="#___icon___check"></use>
								</svg>
							</div>
							<div class="media-body">
								<span class="mt-0 body-strong text-grey-900 font-weight-600">{{
									stationData.reason2title
								}}</span>
								<p class="caption text-grey-900">
									{{ stationData.reason2body }}
								</p>
							</div>
						</div>
						<div v-if="stationData.reason3body" class="media d-flex pb-1">
							<div class="tf-lihe-icons-wrap me-2">
								<svg width="14" height="10" class="icon text-primary-blue">
									<use href="#___icon___check"></use>
								</svg>
							</div>
							<div class="media-body">
								<span class="mt-0 body-strong text-grey-900 font-weight-600">{{
									stationData.reason3title
								}}</span>
								<p class="caption text-grey-900">
									{{ stationData.reason3body }}
								</p>
							</div>
						</div>
						<div v-if="stationData.reason4body" class="media d-flex pb-1">
							<div class="tf-lihe-icons-wrap me-2">
								<svg width="14" height="10" class="icon text-primary-blue">
									<use href="#___icon___check"></use>
								</svg>
							</div>
							<div class="media-body">
								<span class="mt-0 body-strong text-grey-900 font-weight-600">{{
									stationData.reason4title
								}}</span>
								<p class="caption text-grey-900">
									{{ stationData.reason4body }}
								</p>
							</div>
						</div>
						<div v-if="stationData.reason5body" class="media d-flex pb-1">
							<div class="tf-lihe-icons-wrap me-2">
								<svg width="14" height="10" class="icon text-primary-blue">
									<use href="#___icon___check"></use>
								</svg>
							</div>
							<div class="media-body">
								<span class="mt-0 body-strong text-grey-900 font-weight-600">{{
									stationData.reason5title
								}}</span>
								<p class="caption text-grey-900">
									{{ stationData.reason5body }}
								</p>
							</div>
						</div>
					</div>
				</div>
				<!-- END STATION -->
				<!-- CONNNECTED DOMAINS -->
				<DomainsSection :data="data" :stationData="stationData" :descriptionText="descriptionText" :season="season"/>
				<!--  END CONNNECTED DOMAINS -->
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, reactive, watch } from "vue";
// components
// import Map from "@/vue/station-domain/components/map/map.vue";
import PopupBase from "@/vue/common/popupBase.vue";
import StationBanner from "@/vue/station-domain/components/StationBanner.vue";
import DomainsSection from "@/vue/station-domain/components/DomainsInformationSection/DomainsSection.vue"
import StationPopupContent from "@/vue/station-domain/components/stationPopupContent.vue";
import { CustomWindowEvents } from "@/enums/customWindowEvents";

type StationData = Record<string, any>;

const props = defineProps<{
	locale: string;
	stationData: StationData;
}>();

const w = window as Window & {
	content?: any;
	lihe?: { stationId?: string };
	seasonManager?: { season?: string };
};

const stationId = w.lihe?.stationId ?? "";

const data = reactive({
	stationData: null as StationData | null,
	textShowMoreLess: null as unknown,
});

const state = reactive({
	popupOpen: false,
	season: w.seasonManager?.season ?? "",
});

const content = computed(() => w.content);
const season = computed(() => state.season);

const descriptionText = computed(() => {
	if (!props.stationData?.description) return "";
	return props.stationData.description as string;
});

const infoText = computed(() => {
	return season.value === "H"
		? (props.stationData?.infoWinter ?? "")
		: (props.stationData?.infoWSummer ?? "");
});

function handleClosePopup() {
	state.popupOpen = false;
}

function handleOpenPopup() {
	state.popupOpen = true;
}

function onSeasonChange() {
	state.season = w.seasonManager?.season ?? "";

	const merchSection = document.querySelector("section.tf-merchandising");
	if (merchSection && window.seasonManager.isSummer()) { // TEMPORARY - disable and remove merch for summer until a solution is found
		// console.log(`hiding merch on summer`)
		merchSection.classList.add("d-none")
		// merchSection.remove() // TODO change to display none
	}
	else if (merchSection && !window.seasonManager.isSummer()) {
		merchSection.classList.remove("d-none")
	}


}

onMounted(() => {
	window.addEventListener(CustomWindowEvents.CHANGE_SEASON, onSeasonChange);
});

onUnmounted(() => {
	window.removeEventListener(CustomWindowEvents.CHANGE_SEASON, onSeasonChange);
});
</script>

<style>
#stations-vertical {
	top: -12px;
	left: -110px;
}

#summit-container {
	left: 64px;
	top: -14px;
}

#station-distance-container {
	top: 68px;
	right: 77px;
}

@media (max-width: 768px) {
	#station-logo-container {
		left: 30%;
		width: 240px !important;
	}

	#station-distance-container {
		right: 30px;
	}
}
</style>